import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio-modal',
  templateUrl: './portfolio-modal.component.html',
  styleUrls: ['./portfolio-modal.component.scss']
})
export class PortfolioModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
